/**
 * Created by markusr on 16.6.2015.
 */

define('helperNavigation',['require','helperNavigation-getSectionNId','helperNavigation-getSectionNFromEndId','helperNavigation-isLevel1NoChildren','helperNavigation-isLevel1','helperNavigation-isSection1stPage','helperNavigation-isSectionLastPage'],function(require) {
    'use strict';

    var Navigation = {
        getSectionNId: require('helperNavigation-getSectionNId'),
        getSectionNFromEndId: require('helperNavigation-getSectionNFromEndId'),
        isLevel1NoChildren: require('helperNavigation-isLevel1NoChildren'),
        isLevel1: require('helperNavigation-isLevel1'),
        isSection1stPage: require('helperNavigation-isSection1stPage'),
        isSectionLastPage: require('helperNavigation-isSectionLastPage'),
    };

    return Navigation;

});

